import {Type} from '@github-ui/react-query-persister/typebox'

export const CodespaceSchema = Type.Object({
  id: Type.Number(),
  name: Type.String(),
  displayName: Type.String(),
  openUrl: Type.String(),
  branch: Type.String(),
  lastUsedAt: Type.Union([Type.String(), Type.Null()]),
  isActive: Type.Boolean(),
  isFailed: Type.Boolean(),
  isBlocking: Type.Boolean(),
  blockingOperationText: Type.Union([Type.String(), Type.Null()]),
  hasUnpushedChanges: Type.Boolean(),
  hasUncommittedChanges: Type.Boolean(),
  commitsAhead: Type.Number(),
  pullRequest: Type.Union([
    Type.Object({
      number: Type.Number(),
      state: Type.Union([Type.Literal('open'), Type.Literal('closed'), Type.Literal('merged')]),
    }),
    Type.Null(),
  ]),
  isForCurrentRepository: Type.Boolean(),
  isForFork: Type.Boolean(),
  isOwnersFork: Type.Boolean(),
  forkNwo: Type.Union([Type.String(), Type.Null()]),
  autoDeleteSoon: Type.Boolean(),
  retentionExpiresAt: Type.Union([Type.String(), Type.Null()]),
  retentionPeriodDays: Type.Union([Type.Number(), Type.Null()]),
  isUnpublished: Type.Boolean(),
  deletable: Type.Boolean(),
  deleteConfirmationMessage: Type.String(),
  suspendable: Type.Boolean(),
  isReadOnly: Type.Boolean(),
  needsForkToPush: Type.Boolean(),
  needsMachineTypeChange: Type.Boolean(),
  needsBaseImageChange: Type.Boolean(),
  linkDisabled: Type.Boolean(),
  allowChangeMachineType: Type.Boolean(),
  keepDisabled: Type.Boolean(),
  keepEnabled: Type.Boolean(),
  startDisabled: Type.Boolean(),
  paths: Type.Object({
    codespace: Type.String(),
    suspend: Type.String(),
    rename: Type.String(),
    changeMachineType: Type.String(),
    exportControl: Type.String(),
    export: Type.String(),
    exported: Type.String(),
  }),
  exportBranchName: Type.String(),
  exportBranchUrl: Type.Union([Type.String(), Type.Null()]),
  editors: Type.Array(
    Type.Object({
      id: Type.String(),
      label: Type.String(),
      url: Type.String(),
      icon: Type.String(),
      beta: Type.Boolean(),
    }),
  ),
})

export const CodespacesDataSchema = Type.Object({
  header: Type.Object({
    createPath: Type.String(),
    newWithOptionsUrl: Type.String(),
    createFormFields: Type.Object({
      repositoryId: Type.Union([Type.Number(), Type.Null()]),
      pullRequestId: Type.Union([Type.Number(), Type.Null()]),
      expectedBillableOwnerId: Type.Union([Type.Number(), Type.Null()]),
      devcontainerPath: Type.Union([Type.String(), Type.Null()]),
      openInDeeplink: Type.Boolean(),
      allowPermissionsUrl: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    }),
    canCreate: Type.Boolean(),
    disableOneClickCreation: Type.Boolean(),
    configureDevContainerUrl: Type.Union([Type.String(), Type.Null()]),
    prebuildsUrl: Type.Union([Type.String(), Type.Null()]),
    helpUrl: Type.String(),
    manageUrl: Type.String(),
    billableOwnerName: Type.Union([Type.String(), Type.Null()]),
    shareUrl: Type.Optional(Type.String()),
    createNotice: Type.Optional(
      Type.Union([
        Type.Object({
          message: Type.String(),
          linkText: Type.Optional(Type.String()),
          linkUrl: Type.Optional(Type.String()),
        }),
        Type.Null(),
      ]),
    ),
    maintenanceNotice: Type.Optional(
      Type.Union([
        Type.Object({
          message: Type.String(),
          linkText: Type.String(),
          linkUrl: Type.String(),
          dismissPath: Type.String(),
        }),
        Type.Null(),
      ]),
    ),
  }),
  codespaces: Type.Array(CodespaceSchema),
  pullRequestWarning: Type.Union([
    Type.Object({
      message: Type.String(),
      linkText: Type.Optional(Type.String()),
      linkUrl: Type.Optional(Type.String()),
    }),
    Type.Null(),
  ]),
  showActions: Type.Boolean(),
  aliveChannel: Type.Union([Type.String(), Type.Null()]),
  ssoWarning: Type.Union([
    Type.Object({
      message: Type.String(),
    }),
    Type.Null(),
  ]),
})

export type Codespace = Type.Static<typeof CodespaceSchema>
export type CodespacesData = Type.Static<typeof CodespacesDataSchema>
export type CodespacesHeader = CodespacesData['header']
export type CreateFormFields = CodespacesHeader['createFormFields']

export const MANAGE_CODESPACES_URL = '/codespaces'
